import { useQuery } from '@tanstack/react-query';
import Request from '@hotmart/request';

const useBiometricSessionCheck = (active: number, hasError: boolean) =>
  useQuery({
    queryKey: ['biometric.session.check', active],
    queryFn: () =>
      Request('biometric.session.check'),
    enabled: !hasError,
  });

export default useBiometricSessionCheck;
